module.exports = __webpack_public_path__ + "a47abc9cb522c4c491eb4ea485c08a22.jpg";